import React from 'react';
import ReactDOM from 'react-dom';
import { overlayStyle, modalStyle } from './styleModal';

const closeButtonStyleCross = {
    position: 'absolute',
    top: '10px',
    right: '10px',
    width: '20px',
    height: '20px',
    cursor: 'pointer',
    transform: 'rotate(45deg)'
};

const CloseIcon = ({ onClose }) => (
    <div onClick={onClose} style={closeButtonStyleCross}>
        <div style={lineStyle1}></div>
        <div style={lineStyle2}></div>
    </div>
);

const lineStyleBase = {
    position: 'absolute',
    backgroundColor: 'black',
    height: '2px',
    width: '100%',
    top: '50%',
    left: '0',
    transform: 'translateY(-50%)'
};

const lineStyle1 = {
    ...lineStyleBase,
    transform: 'translateY(-50%) rotate(90deg)'
};

const lineStyle2 = lineStyleBase;

const Modal = ({ isOpen, onClose, children }) => {
    if (!isOpen) {
        return null;
    }

    return ReactDOM.createPortal(
        <div style={overlayStyle}>
            <div style={modalStyle}>
                <CloseIcon onClose={onClose} />
                {children}
            </div>
        </div>,
        document.body
    );
};




export default Modal;